import { AxiosResponse } from 'axios';
import IPublishingEvent from '@app/types/base/IPublishingEvent';
import ContentfulService from '../base/ContentfulService';

export default class ScheduledActionsService extends ContentfulService {
	/**
	 * Get a dictionary of all entries that have (un)publishings scheduled as keys
	 * and the ISO unpublishing Date string as values
	 */
	public async getScheduledPublishingEvents(): Promise<Record<string, IPublishingEvent[]>> {
		const response: AxiosResponse = await this.axiosManagementClient.get(`/spaces/${this.spaceId}/scheduled_actions`, {
			params: {
				// eslint-disable-next-line @typescript-eslint/naming-convention
				'environment.sys.id': this.environmentId,
				// eslint-disable-next-line @typescript-eslint/naming-convention
				'sys.status[in]': 'scheduled,succeeded',
				limit: 200
			}
		});

		const scheduledEvents: Record<string, IPublishingEvent[]> = {};

		response.data.items.forEach((item: any): void => {
			scheduledEvents[item.entity.sys.id] = scheduledEvents[item.entity.sys.id] || [];
			scheduledEvents[item.entity.sys.id].push({
				type: item.action,
				dateTime: item.scheduledFor.datetime
			});
		});

		// ensure publishing events are listed in chronological order
		Object.keys(scheduledEvents).forEach((itemId: string): void => {
			scheduledEvents[itemId] = scheduledEvents[itemId].sort(
				(eventA: IPublishingEvent, eventB: IPublishingEvent): number =>
					new Date(eventA.dateTime).getTime() - new Date(eventB.dateTime).getTime()
			);
		});

		return scheduledEvents;
	}
}
